import { APP_WILL_MOUNT } from '../../../react/features/base/app/actionTypes';
import MiddlewareRegistry from '../../../react/features/base/redux/MiddlewareRegistry';
import { setXbeesLangInConference } from './functions';
/**
 * Implements the entry point of the middleware of the xbees/base/conference.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    const result = next(action);
    switch (action.type) {
        case APP_WILL_MOUNT: {
            // @ts-ignore
            const { systemLanguage } = config;
            setXbeesLangInConference(systemLanguage, store);
            break;
        }
    }
    return result;
});
